import { useMemo } from 'react';
import { sortMarketsByPriorityStable } from '@/utils';

export function useMarketFilters({
	markets,
	marketCategories,
}: {
	markets: any[];
	marketCategories: any[];
}) {
	const categoriesObject = useMemo(() => {
		if (!marketCategories?.length) return {};
		return marketCategories.reduce((acc: any, cat: any) => {
			acc[cat.name] = cat.subcategories.map((sub: any) => sub.name);
			return acc;
		}, {});
	}, [marketCategories]);

	const subcategoryIdToNameMap = useMemo(() => {
		if (!marketCategories?.length) return new Map();
		const map = new Map();
		marketCategories.forEach((cat: any) => {
			cat.subcategories?.forEach((sub: any) => {
				if (sub.id) {
					map.set(sub.id, sub.name);
				}
			});
		});
		return map;
	}, [marketCategories]);

	const categoryIdToSubcategoryNamesMap = useMemo(() => {
		if (!marketCategories?.length) return new Map();
		const map = new Map();
		marketCategories.forEach((cat: any) => {
			if (cat.id) {
				map.set(cat.id, cat.subcategories?.map((sub: any) => sub.name) || []);
			}
		});
		return map;
	}, [marketCategories]);

	return {
		categoriesObject,
		subcategoryIdToNameMap,
		categoryIdToSubcategoryNamesMap,
		filteredMarkets: markets,
	};
}
